import { DateTime } from 'luxon';
import React, { createContext, useEffect, useState } from 'react';

import PassApi from 'site-react/api/PassApi';

import logError from 'site-react/core/helpers/logError';

import useRequest from 'site-react/hooks/useRequest';
import useUser from 'site-react/hooks/useUser';

const MembershipContext = createContext();

function MembershipProvider(props) {
  const { isLoggedIn, user } = useUser();
  const [freeTrialDaysRemaining, setFreeTrialDaysRemaining] = useState(null);

  const isReady = !!(isLoggedIn && user?.organisation);
  // Ideally this should be replaced with usePlan as it gives reliable data about an organisation's
  // status. Until then, we don't need more information than a free trial status so this works.
  const { body: freeTrialStatus, exception } = useRequest(
    PassApi,
    'getFreeTrialStatus',
    null,
    isReady,
  );

  useEffect(() => {
    if (exception) {
      logError(exception);
    }
  }, [exception]);

  useEffect(() => {
    if (freeTrialStatus.endDate) {
      const freeTrialEndDate = DateTime.fromISO(freeTrialStatus.endDate);

      const daysRemaining = Math.ceil(
        freeTrialEndDate.diffNow('days').toObject().days,
      );

      setFreeTrialDaysRemaining(daysRemaining);
    }
  }, [freeTrialStatus]);

  const value = { freeTrialDaysRemaining: freeTrialDaysRemaining || null };

  return <MembershipContext.Provider value={value} {...props} />;
}

export { MembershipContext };
export default MembershipProvider;
